import { PresentationalPropertyCardHeader } from './presentational-property-card-header';

interface Props {
  coverImageUrl: string;
  isContentHidden: boolean;
  onlinePlatforms: string[];
  printMode: boolean;
}

export function PropertyCardHeader(props: Props) {
  const { isContentHidden, printMode, coverImageUrl, onlinePlatforms } = props;

  return (
    <PresentationalPropertyCardHeader
      isContentHidden={isContentHidden}
      coverImageUrl={coverImageUrl}
      printMode={printMode}
      onlinePlatforms={onlinePlatforms}
    />
  );
}
